export const toCssSize = (value?: string | number): string | undefined => {
  if (value === undefined || value === '') return undefined;
  return typeof value === 'number' ? `${value}px` : value;
};
